(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaAnnouncementBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-ab]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-ab-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-ab-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-ab-countdown], [data-aa-ab-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaAnnouncementBarInit();
document.addEventListener('shopify:section:load', aaAnnouncementBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-sale-hero"] && !Shopify.designMode) return;
  try {
    
function aaSaleHeroInitCountdowns() {
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    if (el.dataset.aaInit) return;
    el.dataset.aaInit = 'true';

    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var wrap = el.closest('[data-countdown-wrap]');
    var expiredEl = wrap ? wrap.querySelector('[data-expired-message]') : null;
    var sectionEl = el.closest('.aa-sale-hero');
    var hideSection = el.dataset.hideOnExpire === 'true';
    var timer;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (hideSection && sectionEl) sectionEl.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      if (daysEl) daysEl.textContent = pad(Math.floor(diff / 86400000));
      if (hoursEl) hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (minutesEl) minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (secondsEl) secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    timer = setInterval(tick, 1000);
  });
}

function aaSaleHeroInitCopyButtons() {
  document.querySelectorAll('.aa-sale-hero__code-copy').forEach(function (btn) {
    if (btn.dataset.aaInit) return;
    btn.dataset.aaInit = 'true';

    btn.addEventListener('click', function () {
      var text = btn.dataset.copy;
      if (!text || !navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        var original = btn.textContent;
        btn.textContent = btn.dataset.copiedLabel || 'Copied!';
        setTimeout(function () {
          btn.textContent = original;
        }, 2000);
      });
    });
  });
}

// Desktop keeps the highlight on one line; if a long translation doesn't fit the content
// width, scale its text down until it does (mobile wraps instead, so it's left alone).
function aaSaleHeroFitHighlights() {
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  document.querySelectorAll('[data-aa-highlight]').forEach(function (el) {
    el.style.fontSize = '';
    if (!desktop) return;
    var available = el.parentElement.clientWidth - 8;
    var needed = el.scrollWidth;
    if (needed > available && available > 0) {
      var size = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = Math.floor(size * available / needed) + 'px';
    }
  });
}

var aaSaleHeroResizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(aaSaleHeroResizeTimer);
  aaSaleHeroResizeTimer = setTimeout(aaSaleHeroFitHighlights, 150);
});
if (document.fonts && document.fonts.ready) document.fonts.ready.then(aaSaleHeroFitHighlights);

aaSaleHeroInitCountdowns();
aaSaleHeroInitCopyButtons();
aaSaleHeroFitHighlights();
document.addEventListener('shopify:section:load', function () {
  aaSaleHeroInitCountdowns();
  aaSaleHeroInitCopyButtons();
  aaSaleHeroFitHighlights();
});

  } catch(e) { console.error(e); }
})();
})();
